import request from '@/utils/request.js'

//图像技术
export const imageTechnology = (data) => {
  return request({
    url: '/api/standard/image/v1/technology',
    method: 'post',
    data,
  })
}

//整体菜单
export function getMenu() {
  return request({
    url: '/api/standard/algorithm/nav_options',
    method: 'get',
  })
}

//算法列表接口
export function getAlgorithmList(query) {
  return request({
    url: '/api/standard/algorithm',
    method: 'get',
    params: query,
  })
}

//芯片列表接口
export function getChipset(query) {
  return request({
    url: '/api/standard/chipsets/tree',
    method: 'get',
    params: query,
  })
}

//算法详情（带缓存，防止同一id重复请求）
const detailCache = {}
export function getDetail(id) {
  if (detailCache[id]) return detailCache[id]
  const promise = request({
    url: `/api/standard/algorithm/${id}`,
    method: 'get',
  })
  detailCache[id] = promise
  // 请求失败时清除缓存，允许重试
  promise.catch(() => {
    delete detailCache[id]
  })
  return promise
}

// 提交算法贡献
export function submitAlgorithmContribution(data) {
  return request({
    url: '/api/standard/algorithm-submissions',
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data,
  })
}
